import * as React from 'react'
import { useContext, createContext } from 'react'

interface LinkContextProps {
  Link: any
  navigate: Function
}

const LinkContext = createContext<LinkContextProps>(null)

export const useLink = () => useContext(LinkContext)

export const LinkProvider: React.FC<LinkContextProps> = ({
  Link,
  navigate,
  children
}) => {
  const context = {
    Link,
    navigate
  }

  return <LinkContext.Provider value={context}>{children}</LinkContext.Provider>
}
